import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer'; // Import the main Footer component
import BlogHero from './components/BlogHero';
import CategoryFilter from './components/CategoryFilter';
import BlogGrid from './components/BlogGrid';
import PopularPosts from './components/PopularPosts';
import NewsletterSignup from './components/NewsletterSignup';
import GuestPosts from './components/GuestPosts';

const BlogKnowledgeInsightsHub = () => {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Mock blog posts data
  const mockPosts = [
    {
      id: 1,
      title: "Building Scalable React Applications: Advanced Patterns for 2025",
      excerpt: `Explore cutting-edge React patterns that will transform your development workflow. From compound components to advanced state management strategies, learn how to build applications that scale with your team and user base.\n\nThis comprehensive guide covers performance optimization techniques, testing strategies, and architectural decisions that separate good React developers from great ones.`,
      author: "Adrian",
      publishedAt: "2025-01-05",
      readTime: "12 min read",
      difficulty: "Advanced",
      category: "Technical Tutorials",
      tags: ["React", "Architecture", "Performance", "Best Practices"],
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 2847,
      likes: 156,
      comments: 23,
      featured: true
    },
    {
      id: 2,
      title: "The Complete Guide to React Native Performance Optimization",
      excerpt: "Master the art of building lightning-fast mobile applications with React Native. Learn advanced optimization techniques, memory management, and performance monitoring strategies.",
      author: "Adrian",
      publishedAt: "2025-01-03",
      readTime: "15 min read",
      difficulty: "Advanced",
      category: "Technical Tutorials",
      tags: ["React Native", "Performance", "Mobile", "Optimization"],
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 1923,
      likes: 89,
      comments: 17,
      featured: false
    },
    {
      id: 3,
      title: "From Junior to Senior: My 5-Year Development Journey",
      excerpt: "A candid look at my career progression from junior developer to tech lead. Learn about the challenges, breakthroughs, and key decisions that shaped my professional growth.",
      author: "Adrian",
      publishedAt: "2024-12-28",
      readTime: "10 min read",
      difficulty: "Beginner",
      category: "Career Growth",
      tags: ["Career", "Growth", "Leadership", "Experience"],
      image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 3456,
      likes: 234,
      comments: 45,
      featured: false
    },
    {
      id: 4,
      title: "Building CodersHub: Lessons in Community Leadership",
      excerpt: "The story behind creating a thriving developer community. Learn about the challenges, strategies, and principles that helped build CodersHub from the ground up.",
      author: "Adrian",
      publishedAt: "2024-12-25",
      readTime: "8 min read",
      difficulty: "Intermediate",
      category: "Community Building",
      tags: ["Community", "Leadership", "CodersHub", "Growth"],
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 2134,
      likes: 167,
      comments: 32,
      featured: false
    },
    {
      id: 5,
      title: "Mastering React Hooks: Advanced Patterns and Best Practices",
      excerpt: "Deep dive into advanced React Hooks patterns. Learn how to create custom hooks, optimize performance, and build reusable logic that scales across your applications.",
      author: "Adrian",
      publishedAt: "2024-12-20",
      readTime: "14 min read",
      difficulty: "Advanced",
      category: "Technical Tutorials",
      tags: ["React", "Hooks", "Patterns", "JavaScript"],
      image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 1876,
      likes: 98,
      comments: 21,
      featured: false
    },
    {
      id: 6,
      title: "The Art of Technical Mentorship: Guiding the Next Generation",
      excerpt: "Insights from mentoring 100+ developers. Learn effective mentorship strategies, common pitfalls to avoid, and how to create meaningful impact in someone's career.",
      author: "Adrian",
      publishedAt: "2024-12-15",
      readTime: "11 min read",
      difficulty: "Intermediate",
      category: "Career Growth",
      tags: ["Mentorship", "Leadership", "Teaching", "Growth"],
      image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 2567,
      likes: 189,
      comments: 38,
      featured: false
    },
    {
      id: 7,
      title: "State Management in React: Redux vs Context vs Zustand",
      excerpt: "A comprehensive comparison of popular React state management solutions. Learn when to use each approach and how to make the right choice for your project.",
      author: "Adrian",
      publishedAt: "2024-12-10",
      readTime: "13 min read",
      difficulty: "Intermediate",
      category: "Technical Tutorials",
      tags: ["React", "State Management", "Redux", "Context"],
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 1654,
      likes: 87,
      comments: 19,
      featured: false
    },
    {
      id: 8,
      title: "Creating Inclusive Developer Communities: A Practical Guide",
      excerpt: "Learn how to build and maintain inclusive developer communities that welcome everyone. Practical strategies for fostering diversity and creating safe spaces for learning.",
      author: "Adrian",
      publishedAt: "2024-12-05",
      readTime: "9 min read",
      difficulty: "Beginner",
      category: "Community Building",
      tags: ["Inclusion", "Diversity", "Community", "Leadership"],
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 1432,
      likes: 112,
      comments: 28,
      featured: false
    },
    {
      id: 9,
      title: "The Future of Web Development: Trends to Watch in 2025",
      excerpt: "Explore the emerging trends shaping the future of web development. From AI integration to new frameworks, discover what's coming next in our industry.",
      author: "Adrian",
      publishedAt: "2024-11-30",
      readTime: "12 min read",
      difficulty: "Intermediate",
      category: "Industry Insights",
      tags: ["Trends", "Future", "Web Development", "Technology"],
      image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: 2890,
      likes: 201,
      comments: 42,
      featured: false
    }
  ];

  // Simulate loading and set posts
  useEffect(() => {
    const loadPosts = async () => {
      setLoading(true);
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      setPosts(mockPosts);
      setFilteredPosts(mockPosts);
      setLoading(false);
    };

    loadPosts();
  }, []);

  // Filter posts based on category and search query
  useEffect(() => {
    let filtered = posts;

    // Filter by category
    if (activeCategory !== 'all') {
      const categoryMap = {
        'technical': 'Technical Tutorials',
        'career': 'Career Growth',
        'community': 'Community Building',
        'insights': 'Industry Insights'
      };
      // Add a check to ensure post.category exists before comparison
      filtered = filtered.filter(post =>
        post.category === categoryMap[activeCategory]
      );
    }

    // Filter by search query
    if (searchQuery?.trim()) {
      const query = searchQuery.toLowerCase();
      // Remove the redundant `?.` from filter logic
      filtered = filtered.filter(post =>
        (post.title && post.title.toLowerCase().includes(query)) ||
        (post.excerpt && post.excerpt.toLowerCase().includes(query)) ||
        (post.tags && post.tags.some(tag => tag.toLowerCase().includes(query))) ||
        (post.category && post.category.toLowerCase().includes(query))
      );
    }

    setFilteredPosts(filtered);
  }, [posts, activeCategory, searchQuery]);

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
  };

  const handleSearchChange = (query) => {
    setSearchQuery(query);
  };

  return (
    <>
      <Helmet>
        <title>Ebesoh Adrian's Blog - Knowledge & Insights Hub | Adrian Portfolio</title>
        <meta
          name="description"
          content="Explore Ebesoh Adrian's technical insights, career growth strategies, and community building wisdom. Deep-dive tutorials, mentorship tips, and industry perspectives to accelerate your development journey."
        />
        <meta name="keywords" content="React tutorials, career growth, mentorship, community building, web development, technical blog, programming insights" />
        <meta property="og:title" content="Blog - Knowledge & Insights Hub | Adrian Portfolio" />
        <meta property="og:description" content="Technical insights, career growth strategies, and community building wisdom from Adrian - React developer, mentor, and community leader." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ebesohadrian.netlify.app/blogpage" />
        <link rel="canonical" href="https://ebesohadrian.netlify.app/blogpage" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        {/* Add padding to prevent content from hiding under the fixed header */}
        <main className="pt-20 lg:pt-24">
          {/* Hero Section */}
          <BlogHero />

          {/* Category Filter */}
          <CategoryFilter
            onCategoryChange={handleCategoryChange}
            onSearchChange={handleSearchChange}
          />

          {/* Blog Grid */}
          <BlogGrid
            posts={filteredPosts}
            loading={loading}
          />

          {/* Popular Posts */}
          <PopularPosts />

          {/* Guest Posts */}
          <GuestPosts />

          {/* Newsletter Signup */}
          <NewsletterSignup />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default BlogKnowledgeInsightsHub;